import { useState } from "react";
import { Box } from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import { YourLessonOnboarding } from "./your-lesson-onboarding/your-lesson-onboarding";
import { Step2LessonOnboarding } from "./step2-lesson-onboarding/step2-lesson-onboarding";
import { Step3LessonOnboarding } from "./step3-lesson-onboarding/step3-lesson-onboarding";
import { Step4LessonOnboarding } from "./step4-lesson-onboarding/step4-lesson-onboarding";
import { Step5LessonOnboarding } from "./step5-lesson-onboarding/step5-lesson-onboarding";
import { Step6LessonOnboarding } from "./step6-lesson-onboarding/step6-lesson-onboarding";
import { Step7QuizLessonOnboarding } from "./step7-quiz-lesson-onboarding/step7-quiz-lesson-onboarding";
import { Step7LessonOnboarding } from "./step7-lesson-onboarding/step7-lesson-onboarding";
import { Step9LessonOnboarding } from "./step9-lesson-onboarding/step9-lesson-onboarding";
import { Step10LessonOnboarding } from "./step10-lesson-onboarding/step10-lesson-onboarding";
import { Step11LessonOnboarding } from "./step11-lesson-onboarding/step11-lesson-onboarding";
import { Step12LessonOnboarding } from "./step12-lesson-onboarding/step12-lesson-onboarding";
import { Step13LessonOnboarding } from "./step13-lesson-onboarding/step13-lesson-onboarding";
import { Step14LessonOnboarding } from "./step14-lesson-onboarding/step14-lesson-onboarding";
import { Step15LessonOnboarding } from "./step15-lesson-onboarding/step15-lesson-onboarding";
import useAppStore from "../../stores/appStore";

export const LessonOnboarding = () => {
  const { setShowLessonOnboarding } = useAppStore();
  const [step, setStep] = useState(1);

  const handleNext = () => {
    if (step === 15) {
      setShowLessonOnboarding(false);
    } else {
      setStep((prev: number) => prev + 1);
    }
  };

  const handlePrev = () => {
    setStep((prev) => Math.max(prev - 1, 1));
  };

  const handleSkip = () => {
    setShowLessonOnboarding(false);
  };

  const variants = {
    initial: { opacity: 0, x: 50 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -50 },
  };

  return (
    <Box>
      <AnimatePresence mode="wait">
        {step === 1 && (
          <motion.div
            key="step1"
            variants={variants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{ duration: 0.3 }}
          >
            <YourLessonOnboarding
              handleNext={handleNext}
              handleSkip={handleSkip}
            />
          </motion.div>
        )}
        {step === 2 && (
          <motion.div
            key="step2"
            variants={variants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{ duration: 0.3 }}
          >
            <Step2LessonOnboarding
              handlePrev={handlePrev}
              handleNext={handleNext}
              handleSkip={handleSkip}
            />
          </motion.div>
        )}
        {step === 3 && (
          <motion.div
            key="step3"
            variants={variants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{ duration: 0.3 }}
          >
            <Step3LessonOnboarding
              handlePrev={handlePrev}
              handleNext={handleNext}
              handleSkip={handleSkip}
            />
          </motion.div>
        )}
        {step === 4 && (
          <motion.div
            key="step4"
            variants={variants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{ duration: 0.3 }}
          >
            <Step4LessonOnboarding
              handlePrev={handlePrev}
              handleNext={handleNext}
              handleSkip={handleSkip}
            />
          </motion.div>
        )}
        {step === 5 && (
          <motion.div
            key="step5"
            variants={variants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{ duration: 0.3 }}
          >
            <Step5LessonOnboarding
              handlePrev={handlePrev}
              handleNext={handleNext}
              handleSkip={handleSkip}
            />
          </motion.div>
        )}
        {step === 6 && (
          <motion.div
            key="step6"
            variants={variants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{ duration: 0.3 }}
          >
            <Step6LessonOnboarding
              handlePrev={handlePrev}
              handleNext={handleNext}
              handleSkip={handleSkip}
            />
          </motion.div>
        )}
        {step === 7 && (
          <motion.div
            key="step7"
            variants={variants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{ duration: 0.3 }}
          >
            <Step7QuizLessonOnboarding
              handlePrev={handlePrev}
              handleNext={handleNext}
              handleSkip={handleSkip}
            />
          </motion.div>
        )}
        {step === 8 && (
          <motion.div
            key="step8"
            variants={variants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{ duration: 0.3 }}
          >
            <Step7LessonOnboarding
              handlePrev={handlePrev}
              handleNext={handleNext}
              handleSkip={handleSkip}
            />
          </motion.div>
        )}
        {step === 9 && (
          <motion.div
            key="step9"
            variants={variants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{ duration: 0.3 }}
          >
            <Step9LessonOnboarding
              handlePrev={handlePrev}
              handleNext={handleNext}
              handleSkip={handleSkip}
            />
          </motion.div>
        )}
        {step === 10 && (
          <motion.div
            key="step10"
            variants={variants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{ duration: 0.3 }}
          >
            <Step10LessonOnboarding
              handlePrev={handlePrev}
              handleNext={handleNext}
              handleSkip={handleSkip}
            />
          </motion.div>
        )}
        {step === 11 && (
          <motion.div
            key="step11"
            variants={variants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{ duration: 0.3 }}
          >
            <Step11LessonOnboarding
              handlePrev={handlePrev}
              handleNext={handleNext}
              handleSkip={handleSkip}
            />
          </motion.div>
        )}
        {step === 12 && (
          <motion.div
            key="step12"
            variants={variants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{ duration: 0.3 }}
          >
            <Step12LessonOnboarding
              handlePrev={handlePrev}
              handleNext={handleNext}
              handleSkip={handleSkip}
            />
          </motion.div>
        )}
        {step === 13 && (
          <motion.div
            key="step13"
            variants={variants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{ duration: 0.3 }}
          >
            <Step13LessonOnboarding
              handlePrev={handlePrev}
              handleNext={handleNext}
              handleSkip={handleSkip}
            />
          </motion.div>
        )}
        {step === 14 && (
          <motion.div
            key="step14"
            variants={variants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{ duration: 0.3 }}
          >
            <Step14LessonOnboarding
              handlePrev={handlePrev}
              handleNext={handleNext}
              handleSkip={handleSkip}
            />
          </motion.div>
        )}
        {step === 15 && (
          <motion.div
            key="step15"
            variants={variants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{ duration: 0.3 }}
          >
            <Step15LessonOnboarding
              handlePrev={handlePrev}
              handleNext={handleNext}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </Box>
  );
};
